<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/elements-content -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<ng-template cxOutletRef="cx-header">
  @if (isLoginPage$ | async) {
    <cx-global-message></cx-global-message>
  } @else {
    <header>
      <cx-page-layout section="header"></cx-page-layout>
    </header>
    @if (hasHeaderRow$ | async) {
      <div class="breadcrumb col-12 bg-white pl-3 pt-2 pr-3 d-flex flex-column flex-lg-row flex-wrap align-items-center align-left-sm">
        <div class="d-none d-lg-flex col-12 col-lg-6 align-items-center brand menu p-0">
          <cx-page-slot position="NavigationBar"></cx-page-slot>
        </div>
        <div class="float-left p-0 d-block d-sm-block d-lg-none res-brands-btn">
          <div class="col-lg-12 p-0 float-left d-flex align-items-center justify-content-center brand menu">
            <cx-page-slot position="NavigationBar"></cx-page-slot>
          </div>
        </div>
        <div class="col-12 col-lg-6 p-0 res-cart-count">
          <cx-page-slot position="MiniCart" class="cart-count"></cx-page-slot>
        </div>
        <!-- @if (hasBottomHeaderSlot$ | async) {
          <div class="w-100 kn-bottom-header-row res-selected-pages mt-2 pt-2 pb-2 border-top">
            <cx-page-slot position="BottomHeaderSlot"></cx-page-slot>
          </div>
        } -->
      </div>
    }
  <cx-global-message></cx-global-message>
}
</ng-template>
<ng-template cxOutletRef="SiteLogo" cxOutletPos="before" let-model>
  @if (isLoggedIn$ | async) {
    <div class="top-bar-nav float-left">
      <a [attr.aria-hidden]="true" (click)="changeMenuState()"
        class="pt-4 pr-3 pl-0 font-xl-size color-white hover-link cursor-pointer"><i class="fas fa-bars"></i></a>
      </div>
    }
  </ng-template>
  <ng-template cxOutletRef="SiteLogo" cxOutletPos="after">
    @if (isLoggedIn$ | async) {
      <cx-page-slot position="SearchBox"></cx-page-slot>
    }
  </ng-template>
  <ng-template cxOutletRef="SiteContext" cxOutletPos="before">
    @if (customerContext$ | async; as customer) {
      @if (redirectionDetail$ | async; as redirectionDetail) {
        @if (redirectionDetail.switcher) {
          @if (getSelectedSalesAreaName(customer); as salesDivisionName) {
            <span class="sales-division-label d-lg-inline font-size color-white float-left mr-2">{{ salesDivisionName }}</span>
          }
          <div ngbDropdown
            class="logout-btn top-bar-nav float-right mr-2 res-customer-context">
            <span id="dropdownBasic1"
              class="float-left pr-0 pl-0 font-size color-white hover-link cursor-pointer customer-context d-flex align-items-center justify-content-end"
              ngbDropdownToggle>
              <span class="cart-context d-flex align-items-center mr-1">
                <div class="res-cart-context float-left">
                  <span [title]="customer.customerName"><i class="fas fa-building mr-2 p-res-0" aria-hidden="true"></i>{{ customer.customerNumber |
                removeLeadingZeros }} {{ customer.customerName}}</span>
                <!-- @if (customer.telephone) {
                  <br />
                  <span>
                    <i class="fas fa-phone-square mr-2 p-res-0" aria-hidden="true"></i>
                    {{ 'label.phoneNo' | cxTranslate }} {{ customer.telephone }}
                  </span>
                } -->
              </div>
            </span>
          </span>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu knbr-dropdown">
            <a class="font-size" [routerLink]="{ cxRoute: 'switchAccount' } | cxUrl" ngbDropdownItem>{{
              'label.change' | cxTranslate
            }}</a>
            <a [attr.aria-hidden]="true" class="font-size" (click)="removeCustomerContext()" ngbDropdownItem>{{
              'label.remove' | cxTranslate
            }}</a>
          </div>
        </div>
      } @else {
        <div class="logout-btn top-bar-nav float-right mr-2 res-customer-context">
          <span
            class="float-left pr-0 pl-0 font-size color-white hover-link customer-context d-flex align-items-center justify-content-end">
            <span class="cart-context d-flex align-items-center mr-1">
              <div class="res-cart-context float-left">
                @if (getSelectedSalesAreaName(customer); as salesDivisionName) {
                  <span class="sales-division-label d-none d-lg-inline mr-1">{{ salesDivisionName }}</span>
                }
                <span [title]="customer.customerName"><i class="fas fa-building mr-2 p-res-0" aria-hidden="true"></i>{{ customer.customerNumber |
              removeLeadingZeros }} {{ customer.customerName }}</span>
              <!-- @if (customer.telephone) {
                <br />
                <span><i class="fas fa-phone-square mr-2 p-res-0" aria-hidden="true"></i>{{ 'label.phoneNo' |
              cxTranslate }} {{ customer.telephone }}</span>
            } -->
          </div>
        </span>
      </span>
    </div>
  }
} @else {
  <div class="logout-btn top-bar-nav float-right mr-2 res-customer-context">
    <span
      class="float-left pr-0 pl-0 font-size color-white hover-link customer-context d-flex align-items-center justify-content-end">
      <span class="cart-context d-flex align-items-center mr-1">
        <div class="res-cart-context float-left">
          @if (getSelectedSalesAreaName(customer); as salesDivisionName) {
            <span class="sales-division-label d-none d-lg-inline mr-1">{{ salesDivisionName }}</span>
          }
          <span [title]="customer.customerName"><i class="fas fa-building mr-2 p-res-0" aria-hidden="true"></i>{{ customer.customerNumber |
        removeLeadingZeros }} {{ customer.customerName }}</span>
        <!-- @if (customer.telephone) {
          <br />
          <span><i class="fas fa-phone-square mr-2 p-res-0" aria-hidden="true"></i>{{ 'label.phoneNo' |
        cxTranslate }} {{ customer.telephone }}</span>
      } -->
    </div>
  </span>
</span>
</div>
}
} @else {
  @if (isLoggedIn$ | async) {
    <div class="logout-btn top-bar-nav float-right mr-2 cursor-pointer">
      <a [routerLink]="{ cxRoute: 'switchAccount' } | cxUrl"
        class="pt-3 pr-0 pl-3 pb-3 font-size color-white hover-link">
        <i class="fas fa-building pr-2"></i>
      </a>
    </div>
  }
}
@if (user$ | async; as user) {
  @if (isLoggedIn$ | async) {
    <div class="logout-btn top-bar-nav float-right mr-2 cursor-pointer res-user res-user d-none d-sm-none d-lg-block"
      >
      <span href="" class="pt-4 pr-0 pl-2 pb-4 font-size color-white hover-link user-span custo">
        <i class="fas fa-user-circle pr-2" aria-hidden="true"></i>
        <span class="user-name"> {{ user.name }} </span>
      </span>
    </div>
  }
}
<!-- <div class="logout-btn top-bar-nav float-left cursor-pointer language">
  <span href="" class="pt-4 pr-0 pl-2 pb-4 font-lg-size color-white hover-link">
    <i class="fas fa-language pr-2" aria-hidden="true"></i>
  </span>
</div> -->
</ng-template>
@if (isStaticPage$ | async) {
  <ng-template cxOutletRef="SiteContext" cxOutletPos="after">
    @if (!(isLoggedIn$ | async)) {
      <a class="font-size color-white hover-link signup-link ml-3 mr-3" [routerLink]="{ cxRoute: 'register' } | cxUrl">{{
        'loginForm.signUp' | cxTranslate
      }}</a>
    }
    @if (!(isLoggedIn$ | async)) {
      <a class="font-size color-white hover-link signin-link" [routerLink]="{ cxRoute: 'login' } | cxUrl">{{
        'loginForm.signIn' | cxTranslate
      }}</a>
    }
  </ng-template>
}
<ng-template cxOutletRef="SiteContext" cxOutletPos="after">
  @if (isLoggedIn$ | async) {
    <button class="logout-button" (click)="logout()">
      {{ 'label.logout' | cxTranslate }}
    </button>
  }
</ng-template>
